import { Component, Inject, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { MatChipInputEvent } from "@angular/material/chips";
import { COMMA, ENTER, TAB } from '@angular/cdk/keycodes';
import { SaveService } from '../../../services/save.service';
import { DefaultValuesService } from '../../../services/defaultvalues.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DialogService } from "../../../services/dialog.service";
import { Utils } from "../../../utils/utils";
import { ChangeHistoryDialogue } from "../dialog-change-history/dialog-change-history";
import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: "contacttounit-list",
    templateUrl: './contacttounit-list.component.html',
    styleUrls: ['./contacttounit-list.component.less', '../../../style/mat-table.component.less'],
    standalone: false
})

export class ContactToUnitListComponent implements OnInit {
    @Input('list') list: ContactToUnit[] = [];
    @Input('showLocalFilter') showLocalFilter = false;

    columnsToDisplay = ['index', 'ContactId', 'CustomerId', 'ContractNumber', 'UnitId', 'IsDeleted', 'ChangedAtUtc','actions'];


    booleanColumns = ['IsDeleted']
    dateColumns = ['ChangedAtUtc', 'ReportingDate']

    notEditableColumns = ['index', 'ContactId', 'CustomerId', 'ContractNumber', 'UnitId', 'ChangedAtUtc'];

    @ViewChild(MatTable, { static: true }) table!: MatTable<any>;

    public dataSource = new MatTableDataSource<ContactToUnit>();
    selected: ContactToUnit | undefined;


    clonedList: { [s: string]: ContactToUnit } = {};

    filter = '';

    subscriptionTenant: any;

    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [COMMA, TAB, ENTER];
    searchItems: SearchItem[] = [];

    constructor(private activatedRoute: ActivatedRoute
        , private router: Router
        , private http: HttpClient
        , private saveService: SaveService
        , private defaults: DefaultValuesService
        , private confimDialog: DialogService
        , @Inject('BASE_URL') private baseUrl: string
        , private readonly dialog: MatDialog
        , private readonly toastrService: ToastrService
    ) {
    }

    ngOnChanges() {
        this.dataSource.data = this.list
        this.clonedList = {}
        this.saveService.showSaveButton(false)
        this.saveService.addListener(this)
    }

    ngOnInit() {
        this.getHeader();
        this.subscriptionTenant = this.defaults.tenantMessageChanges$.subscribe(() => {
            this.getHeader()
        });
        this.saveService.addListener(this);
        this.dataSource.filterPredicate = (data: ContactToUnit, filters: string) => {
            const matchFilter: any[] = [];
            const filterArray = filters.split('+').filter(x => x.indexOf('notextfilters') < 0)
            if (filterArray.length > 0) {
                filterArray.forEach((filter) => {
                    let result = false;
                    this.columnsToDisplay.forEach((column) => {
                        const value = data[column]
                        if (value && value.toString().toLowerCase().includes(filter.toLowerCase())) {
                            result = true;
                        }
                    })
                    matchFilter.push(result);
                });
            } else {
                matchFilter.push(true);
            }
            return matchFilter.some(Boolean);
        };
    }


    getHeader() {
        if (!this.defaults.isReadonlyUser) {
            this.columnsToDisplay = ['index', 'ContactId', 'CustomerId', 'ContractNumber', 'UnitId', 'IsDeleted', 'ChangedAtUtc', 'actions'];
        }
        else {
            this.columnsToDisplay = ['index', 'ContactId', 'CustomerId', 'ContractNumber', 'UnitId', 'IsDeleted', 'ChangedAtUtc'];
        }
    }

    getInput(data: ContactToUnit, property: string): any {
        return data[property];
    }

    getDataType(property: string) {
        let result = ''
        if (this.booleanColumns.indexOf(property) > -1) result = 'boolean'
        else if (this.dateColumns.indexOf(property) > -1) result = 'date'
        else result = 'string'
        return result
    }

    changeElement(object: any, type: string, value: boolean) {
        object[type] = value;
        this.table.renderRows();
    }

    onRowEditInit(contractToUnit: ContactToUnit) {
        this.saveService.addListener(this);
        this.clonedList[this.getDictionaryHash(contractToUnit)] = { ...contractToUnit };
        if (Object.keys(this.clonedList).length !== 0) this.onShowSavebutton()
    }

    onRowEditCancel(contractToUnit: ContactToUnit) {
        this.dataSource.data[this.dataSource.data.findIndex(x => x.UnitId === contractToUnit.UnitId && x.ContactId === contractToUnit.ContactId && x.CustomerId == contractToUnit.CustomerId && x.ContractNumber === contractToUnit.ContractNumber)] = this.clonedList[this.getDictionaryHash(contractToUnit)];
        delete this.clonedList[this.getDictionaryHash(contractToUnit)];
        if (Object.keys(this.clonedList).length === 0) this.saveService.showSaveButton(false)
        this.table.renderRows();
    }

    isEditingRow(contractToUnit: ContactToUnit, property: string) {
        return this.clonedList[this.getDictionaryHash(contractToUnit)] &&
            (this.notEditableColumns.indexOf(property) < 0)
    }

    onShowSavebutton() {
        this.saveService.showSaveButton();
    }

    onSave() {
        let updatedList: any[] = []
        for (let i in this.clonedList) {
            const tokens = i.split("_");
            const index = this.dataSource.data.findIndex(x => x.UnitId === tokens[0] && x.ContractNumber === tokens[1] && x.CustomerId === tokens[2])
            const item = this.dataSource.data[index]
            updatedList.push({ ...item })
        }
        if (updatedList.length > 0)
            Utils.httpUpdateContactToUnit(
                this.http
                , this.baseUrl
                , this.defaults.stage
                , updatedList
                , this
                , function (tthis: any, list: ContactToUnit[]) {
                    tthis.toastrService.success('Contact(s) To Unit were updated successfully!');
                    tthis.clonedList = {}
                    tthis.saveService.showSaveButton(false)
                    tthis.table.renderRows();
                }, function (tthis: ContactToUnitListComponent, message: string) {
                    tthis.saveService.addListener(tthis)
                    tthis.saveService.showSaveButton(true)
                    tthis.confimDialog.showErrorDialog(message);
                }
            );

        updatedList = []
    }

    applyFilter(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            this.searchItems.push({ name: value.replace('+', '').trim() });
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
        this.updatefilter()
    }

    remove(item: SearchItem): void {
        const index = this.searchItems.indexOf(item);
        if (index >= 0) {
            this.searchItems.splice(index, 1);
        }
        this.updatefilter()
    }
    updatefilter() {
        let filterString: string
        if (this.searchItems.length === 0) {
            this.dataSource.filter = 'notextfilters'
        } else {
            filterString = this.searchItems.map(e => e.name).join('+')
            this.dataSource.filter = filterString
        }
    }

    getDictionaryHash(contractToUnit: ContactToUnit) {
        return contractToUnit.UnitId + '_' + contractToUnit.ContractNumber + '_' + contractToUnit.CustomerId + '_' + contractToUnit.ContactId
    }
    openChangeHistoryDialog(element: any) {
        const filteredElement = element ? Object.fromEntries(
            Object.entries(element).filter(([key]) => this.columnsToDisplay.includes(key))
        ) : undefined;
        console.log(filteredElement);
        if (filteredElement && element.TenantId) {
            filteredElement["TenantId"] = element.TenantId;
        }
        this.dialog.open(ChangeHistoryDialogue, {
            height: '535px',
            width: '900px',
            data: {
                entity: 'ContactToUnit',
                row: filteredElement,
            }
        });
    }

}
export interface SearchItem {
    name: string;
}
